/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const bookingRegionsResponseSchema = z.object({
	regions: z.array(z.object({ placeableFrom: z.string(), placeableTo: z.string() })),
})

export type BookingRegionsResponseSchema = z.infer<typeof bookingRegionsResponseSchema>
